/* eslint-disable array-callback-return */
import React from "react";
import { useHistory } from "react-router-dom";
import BoardCss from "./board.css";

const BoardWrite = () => {
  //API 통신시 필요한 게시글 상세 번호
  const BoardTitle = ["제목", "작성자", "연락처", "비밀번호"];
  const history = useHistory();
  const BoardWriteBtn = () => {};
  const BoardList = () => {
    history.goBack();
  };
  const InputValue = [
    {
      InputName: "Title",
      Value: ""
    },
    {
      InputName: "Username",
      Value: ""
    },
    {
      InputName: "PhoneNumber",
      Value: ""
    },
    {
      InputName: "Password",
      Value: ""
    },
    {
      InputName: "Content",
      Value: ""
    }
  ];

  const onChangeValue = e => {
    InputValue.map(data => {
      if (e.target.id === data.InputName) {
        data.Value = e.target.value;
      }
    });
  };

  const BoardWriteInput = Title => {
    switch (Title) {
      case "제목":
        return (
          <div className="BoardWriteContent">
            <input
              id="Title"
              onChange={onChangeValue}
              className="BoardWriteInputTitle"
              type="text"
            ></input>
          </div>
        );
      case "작성자":
        return (
          <div className="BoardWriteContent">
            <input id="Username" onChange={onChangeValue} type="text"></input>
          </div>
        );
      case "연락처":
        return (
          <div className="BoardWriteContent">
            <input
              id="PhoneNumber"
              onChange={onChangeValue}
              placeholder="'-' 없이 입력하세요."
              type="text"
            ></input>
          </div>
        );
      case "비밀번호":
        return (
          <div className="BoardWriteContent BoardWritePassword">
            <input id="Password" onChange={onChangeValue} type="text"></input>
            <div>
              <span>
                ※ 게시판의 모든 글은 비밀번호를 입력하신 후 확인하실수 있습니다.
              </span>
            </div>
          </div>
        );
      default:
        break;
    }
  };
  return (
    <BoardCss.BoardWriteContainer>
      <div className="BoardWrite">
        {BoardTitle.map((data, index) => (
          <div key={index} className="BoardWriteRow">
            <div className="BoardWriteTitle">{data}</div>
            {BoardWriteInput(data)}
          </div>
        ))}
        <div className="BoardWriteRow">
          <div className="BoardDetailDescription">
            <textarea id="Content" onChange={onChangeValue}></textarea>
          </div>
        </div>
      </div>
      <button type="button" onClick={BoardWriteBtn}>
        등록
      </button>
      <button type="button" onClick={BoardList} className="BoardWriteCancel">
        취소
      </button>
    </BoardCss.BoardWriteContainer>
  );
};

export default BoardWrite;
